// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetNewbuildingsForDeveloperCardRequest,
  TGetNewbuildingsForDeveloperCardModel,
  IMappers,
  TGetNewbuildingsForDeveloperCardResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingsForDeveloperCardResponse } from '../../entities/get_newbuildings_for_developer_card/GetNewbuildingsForDeveloperCardResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingsForDeveloperCardModel(
  parameters: TGetNewbuildingsForDeveloperCardRequest,
): TGetNewbuildingsForDeveloperCardModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-search',
    pathApi: '/v1/get-newbuildings-for-developer-card/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetNewbuildingsForDeveloperCardOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetNewbuildingsForDeveloperCardRequest;
}

export async function fetchGetNewbuildingsForDeveloperCard<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingsForDeveloperCardOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingsForDeveloperCardResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingsForDeveloperCardModel(parameters),
    config,
  )) as FetchResponse<TGetNewbuildingsForDeveloperCardResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsForDeveloperCardResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingsForDeveloperCardResponse>;
}
